<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">
      {{ $t("viewSettings.navigation_menu.title") }}
    </h3>
    <v-card class="mt-2" elevation="0">
      <v-form
        >

          <v-data-table
              :loading="isLoadingNavigationMenu"
            v-if="isReady"
            :items-per-page="1000"
            hide-default-footer
            :headers="[
              {
                text: $t('common.visibility'),
                align: 'start',
                sortable: false,
                value: 'is_hidden',
              },
              { text: $t('common.title'), value: 'text' },
              { text: '', value: 'align' },
            ]"
            :items="preparedItems.filter(item=>(userHasRight(item.right) || ! item.right ) && ! isLoadingNavigationMenu)"
            v-sortable-data-table
            @sorted="saveOrder"
            item-key="name"
            :item-class="getRowClass"
          >
            <template v-slot:item.is_hidden="props">
              <v-simple-checkbox
                :disabled="props.item.always_first"
                @click="
                  !props.item.always_first
                    ? toggleVisibility(props.item)
                    : null
                "
                :value="props.item.always_first || props.item.is_hidden === false"
                class="d-inline"
              />
            </template>
            <template v-slot:item.text="props">
            {{ $t(props.item.text) }}
            </template>
            <template v-slot:item.align="props">
              <v-icon class="mr-5 pointer" v-if="props.item.always_first === undefined">fa-arrows-alt-v</v-icon>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:loading>
              {{ $t("common.loading") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>

        <v-divider class=""></v-divider>
        <v-card-actions>
          <v-btn
            class="white--text"
            elevation="0"
            color="warning"
            @click="restore"
            :loading="isLoadingNavigationMenu"
            :disabled="isLoadingNavigationMenu"
          >
            {{ $t("common.restore_default") }}
          </v-btn>
          <v-btn
            class="white--text"
            elevation="0"
            color="primary"
            :loading="isLoadingNavigationMenu"
            :disabled="
              isLoadingNavigationMenu
            "
            @click="save"
          >
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";
import router from "../../router";
import Sortable from "sortablejs";
import RightsMixin from "@/mixins/rights";
export default {
  mixins: [RightsMixin],
  data: () => ({
    isReady: true,
    tmpItems: []
  }),
  created() {},
  mounted() {
    this.$store.dispatch('navigation_menu/get')
  },
  computed: {
    ...mapFields("navigation_menu", [
      "isLoadingNavigationMenu",
      "navigationMenu",
      "items",
    ]),
    preparedItems(){
      return this.tmpItems;
    }
  },
  watch: {
    isLoadingNavigationMenu(to){
      if(!to){
        this.tmpItems = JSON.parse(JSON.stringify(this.items))
      }
    }
  },
  methods: {
    getRowClass(item){
      if(item.always_first) return 'disabled'
    },
    async restore() {
      await this.$store.dispatch("navigation_menu/remove").then(()=>{
        this.$store.dispatch("navigation_menu/get");
      })
    },
    toggleVisibility(item){
      this.tmpItems.forEach((el)=>{
        if(el.text === item.text){
          el.is_hidden = !el.is_hidden;
        }
      })
      this.tmpItems = JSON.parse(JSON.stringify(this.tmpItems))
    },
    saveOrder(ordered){
      this.isReady = false;
      let item = JSON.parse(JSON.stringify(this.tmpItems[ordered.oldIndex]))
      this.tmpItems.splice(ordered.oldIndex, 1);
      this.tmpItems.splice(ordered.newIndex, 0, item);
      this.$nextTick(()=>{
        this.isReady = true;
      })
    },
    save() {
      if(this.tmpItems.length===0) return;
      let data = []
      this.tmpItems.forEach((el)=>{

        if(!el.text || el.text===''){
          throw "Empty parameter value for column at save() method";
        }
        let item = {}
        item[el.text] = !el.is_hidden;
        data.push(item)
      })
      this.$store.dispatch("navigation_menu/store", data).then(()=>{
        this.$store.dispatch("navigation_menu/get");
      })
    },
  },
  directives: {
    sortableDataTable: {
      bind (el, binding, vnode) {

        const options = {
          animation: 150,
          //forceFallback: true,
          preventOnFilter: true, // Call `event.preventDefault()` when triggered `filter`
          filter: ".disabled",
          sort:true,
          onMove:  (/**Event*/evt) => {
            if(evt.related.classList.contains('disabled')){
              return false;
            }
          },
          onUpdate: function (event) {

            vnode.child.$emit('sorted', event)
          },
        }
        Sortable.create(el.getElementsByTagName('tbody')[0], options)
      }
    }
  },
};
</script>

<style scoped></style>
